import React, { FC, memo } from "react";
// libs
import NextImage from "next/image";
import isEqual from "lodash/isEqual";
// utils
import { getClinicImagePath } from "src/utils/clinics";
import { calcReviewsCount, calcAvgRating } from "src/utils/reviews";
// theme
import {
  Row,
  Wrapper,
  ImageContainer,
  NextImageWrapper,
  ImageText,
  ClinicTitle,
  ClinicAddress,
  RatingCountText,
  RateText,
  SpeciesList,
  SpeciesItem,
} from "./clinic.styles";
// types
import { IClinicCardProps } from "./clinic.types";

const ClinicCard: FC<IClinicCardProps> = ({
  name,
  logo_url,
  address,
  rating,
  services = [],
  fromPetsapp,
}) => {
  const reviewsCount = calcReviewsCount(rating);
  const avgRating = Number(calcAvgRating(rating));

  return (
    <Wrapper>
      <ImageContainer>
        <NextImageWrapper bg={getClinicImagePath(logo_url)} />
        {fromPetsapp && <ImageText>Recommended</ImageText>}
      </ImageContainer>

      <ClinicTitle>{name}</ClinicTitle>
      <Row margin={`6px 0 0 0`}>
        {/*<Row margin={`6px 0 ${!!species?.length ? '20px' : '0'} 0`}>*/}
        <ClinicAddress>{address}</ClinicAddress>
        {!!reviewsCount && !!avgRating && (
          <>
            <NextImage src={"/icons/star-full-blue.svg"} width={27} height={27} />
            <RatingCountText>{avgRating}</RatingCountText>
          </>
        )}
      </Row>
      <SpeciesList>
        {(services as string[]).slice(0, 4).map((item: any) => (
          <SpeciesItem key={item}>{item}</SpeciesItem>
        ))}
      </SpeciesList>
    </Wrapper>
  );
};

export default memo(ClinicCard, isEqual);
